module.exports = __webpack_public_path__ + "static/img/zhibao.434513e1.png";